
import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw, Settings } from 'lucide-react';
import { AIMessage } from '@/contexts/ai-assistant/types';
import MessageList from './MessageList';
import InputBar from './InputBar';
import ErrorDisplay from './ErrorDisplay';

interface ChatTabProps {
  messages: AIMessage[];
  inputValue: string;
  setInputValue: (value: string) => void;
  handleSendMessage: () => void;
  clearMessages: () => void;
  rateResponse: (messageId: string, rating: 'helpful' | 'not-helpful') => void;
  error: string | null;
  clearError: () => void;
  isLoading: boolean;
  onSourceClick: (url: string) => void;
  setActiveTab: (tab: string) => void;
  isOpen: boolean;
}

const ChatTab: React.FC<ChatTabProps> = ({
  messages,
  inputValue,
  setInputValue,
  handleSendMessage,
  clearMessages,
  rateResponse,
  error,
  clearError,
  isLoading,
  onSourceClick,
  setActiveTab,
  isOpen
}) => {
  return (
    <div className="flex-1 flex flex-col h-full px-6 pb-6">
      <ErrorDisplay error={error} clearError={clearError} />
      
      <MessageList 
        messages={messages} 
        rateResponse={rateResponse}
        onSourceClick={onSourceClick}
      />
      
      <InputBar 
        inputValue={inputValue}
        setInputValue={setInputValue}
        handleSendMessage={handleSendMessage}
        isLoading={isLoading}
        isOpen={isOpen}
      />
      
      <div className="flex justify-between mt-2">
        <Button 
          variant="ghost" 
          size="sm" 
          className="text-xs"
          onClick={clearMessages}
          disabled={isLoading}
        >
          <RefreshCw className="h-3 w-3 mr-1" /> New conversation
        </Button>
        <Button 
          variant="ghost" 
          size="sm" 
          className="text-xs"
          onClick={() => setActiveTab('settings')}
          disabled={isLoading}
        >
          <Settings className="h-3 w-3 mr-1" /> Settings
        </Button>
      </div>
    </div>
  );
};

export default ChatTab;
